import { Phone, FileText, Star, Shield, MapPin } from "lucide-react";
import { BUSINESS, IMAGES } from "../../data/business";

export default function Hero() {
  return (
    <section id="top" className="relative gradient-soft-blue pt-12 md:pt-20 pb-16 md:pb-24 overflow-hidden">
      {/* soft pattern dots */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(#1E3A8A 1px, transparent 1px)",
          backgroundSize: "22px 22px",
        }}
      />
      <div className="container-ss relative grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="flex flex-wrap items-center gap-2 mb-5 fade-up">
            <span className="pill"><MapPin size={12} /> Northwest Indiana</span>
            <span className="pill pill-green"><Star size={12} className="fill-emerald-700" /> Family & Woman-Owned</span>
            <span className="pill"><Shield size={12} /> Residential & Commercial</span>
          </div>

          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-[1.05] tracking-tight fade-up d-1">
            Professional Cleaning <br className="hidden md:block" />
            Services You Can <span className="text-[#1E3A8A]">Trust</span>.
          </h1>

          <p className="mt-5 text-base md:text-lg text-slate-600 max-w-xl leading-relaxed fade-up d-2">
            Reliable residential and commercial cleaning for homes, offices, churches and businesses
            across Northwest Indiana. Locally owned, detail-oriented, and committed to helping every
            space feel fresh, clean and cared for.
          </p>

          <div className="mt-7 flex flex-wrap gap-3 fade-up d-3">
            <a href="#quote" className="btn-primary" data-testid="hero-quote-btn">
              <FileText size={16} /> Request a Free Quote
            </a>
            <a href={BUSINESS.phoneHref} className="btn-green" data-testid="hero-call-btn">
              <Phone size={16} /> Call {BUSINESS.phone}
            </a>
            <a href="#reviews" className="btn-outline" data-testid="hero-reviews-btn">
              <Star size={16} /> View Reviews
            </a>
          </div>

          <div className="mt-8 flex items-center gap-4 fade-up d-4">
            <div className="flex -space-x-2">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="h-9 w-9 rounded-full ring-2 ring-white bg-gradient-to-br from-sky-200 to-blue-400"
                />
              ))}
            </div>
            <div className="text-sm text-slate-600">
              <div className="text-slate-800 font-semibold">Owner-operated by Stephanie Spiehler</div>
              <span className="text-slate-500">8+ years of hands-on cleaning experience</span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 relative fade-up d-2">
          <div className="relative rounded-3xl overflow-hidden border border-slate-200 shadow-xl">
            <img
              src={IMAGES.hero}
              srcSet={`${IMAGES.heroSmall} 640w, ${IMAGES.hero} 1024w`}
              sizes="(min-width: 1024px) 520px, 100vw"
              width="1024"
              height="1024"
              fetchPriority="high"
              decoding="async"
              alt="Bright clean living room cleaned by S.S. Cleaning Solutions"
              className="w-full h-[420px] md:h-[520px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent" />
          </div>

          <div className="hidden md:flex absolute -bottom-6 -left-6 bg-white border border-slate-200 rounded-2xl shadow-lg px-5 py-4 items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-700">
              <Shield size={18} />
            </div>
            <div>
              <div className="text-sm font-semibold text-slate-900">Reliable & Detailed</div>
              <div className="text-xs text-slate-500">No cut corners</div>
            </div>
          </div>

          <div className="hidden md:flex absolute -top-5 -right-5 bg-white border border-slate-200 rounded-2xl shadow-lg px-5 py-4 items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-sky-100 flex items-center justify-center text-[#1E3A8A]">
              <Star size={18} />
            </div>
            <div>
              <div className="text-sm font-semibold text-slate-900">Real Reviews</div>
              <div className="text-xs text-slate-500">On Google &amp; Facebook</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
